// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*export const environment = {
	production: false,
	prefixSentry: 'dev',
	baseApiUrl: 'https://test-sm-api.quickorder.io/api/',
	pusherKey: '368bd6ee50da53356e74',
	stripeApiToken: 'pk_test_gGYDpK7KeUIJLhzaZvomqjde00Gz9qcyfv',
	pushManagerAppKey: 'BKZUPCQEDs6uoXNGUgbrZQGCEVXMAtl07AOH89mdqwddrhRz5nBOzPWbyVm3pdKfWyIP7T_P2smLW7pP0DyKq44',
	posUrl: 'https://mytdd-dev.shopbox.com/',
	qoEnvironment: 'DEV',
};*/

export const environment = {
	production: true,
	prefixSentry: 'prod',
	baseApiUrl: 'https://sm-api.quickorder.io/api/',
	pusherKey: 'f6444d0299e0928cf9f1',
	stripeApiToken: 'pk_live_64AoFYZDZ7PCErrAxAKjYSIY002NQkupOy',
	pushManagerAppKey: 'BKZUPCQEDs6uoXNGUgbrZQGCEVXMAtl07AOH89mdqwddrhRz5nBOzPWbyVm3pdKfWyIP7T_P2smLW7pP0DyKq44',
	posUrl: 'https://my.shopbox.com/',
	qoEnvironment: 'PROD',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * ON PERFORMANCE IF AN ERROR IS THROWN.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
